import { render } from "./FormStack.vue?vue&type=template&id=394d81a1"
import script from "./FormStack.vue?vue&type=script&lang=js"
export * from "./FormStack.vue?vue&type=script&lang=js"
script.render = render

export default script